// https://vuex.vuejs.org/en/getters.html

export default {
  taxRates(state) {
    return state.taxRates;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
